export default __webpack_public_path__ + "static/media/LogoNameWhite.dd22df8c.svg";